<template>
  <div id="app" class="purchase-history-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <h2 class="page-title">积分扣减</h2>
    </div>

    <!-- 筛选区域 -->
    <div class="filter-section">
      <el-form :inline="true" size="small" :model="filterForm">
        <el-form-item label="">
          <el-input 
            v-model="filterForm.certNo" 
            placeholder="请输入身份证号码" 
            size="small"
            style="width: 180px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input 
            v-model="filterForm.personName" 
            placeholder="请输入姓名" 
            size="small"
            style="width: 150px;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            size="small" 
            @click="handleQuery" 
            icon="el-icon-Ssearch"
          >
            查询
          </el-button>
          <el-button 
            size="small" 
            @click="handleReset"
          >
            重置
          </el-button>
        </el-form-item>
        <el-form-item>
         <!-- <el-button
            type="success" 
            size="mini" 
            icon="el-icon-plus"
            @click="handleAddNew"
          >
            新增
          </el-button> -->
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-section" :style="{ height: tableHeight + 'px' }">
      <div class="table-container">
        <el-table
          :data="tableData"
          :height="tableInnerHeight"
          border
          style="width: 100%"
          :row-style="{ height: rowHeight + 'px' }"
          :cell-style="{ padding: cellPadding + 'px' }"
          :header-cell-style="{ 
            'font-size': headerFontSize + 'px',
            'font-weight': 'bold',
            'background-color': '#f5f7fa'
          }"
          ref="mainTable"
        >
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          
          <!-- 根据接口返回的字段显示 -->
          <el-table-column 
            prop="bizSoucName" 
            label="业务来源" 
            width="120"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          
          <el-table-column 
            prop="docNum" 
            label="单据编号" 
            width="180"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          
          <el-table-column 
            prop="certNo" 
            label="证件号码" 
            width="180"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          
          <el-table-column 
            prop="patId" 
            label="健康卡号" 
            width="120"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          
          <el-table-column 
            prop="personName" 
            label="人员名称" 
            width="120"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          
          <el-table-column 
            prop="reduceNum" 
            label="扣减数量" 
            width="100"
            align="center"
          >
          </el-table-column>
          
          <el-table-column 
            prop="busDate" 
            label="业务日期" 
            width="120"
            align="center"
          >
          </el-table-column>
          
          <el-table-column 
            prop="createTime" 
            label="创建时间" 
            width="180"
            align="center"
          >
          </el-table-column>
          
          <el-table-column 
            prop="remark" 
            label="备注" 
            min-width="200"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          
          <!-- 操作列 - 只保留查看按钮 -->
          <el-table-column label="操作" width="80" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="mini" 
                @click="handleViewDetail(scope.row)"
              >
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-section">
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <!-- 新增积分扣减模态框 -->
    <el-dialog
      title="新增积分扣减"
      :visible.sync="showAddDialog"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="handleAddDialogClose"
      width="500px"
      top="5vh"
      class="add-points-dialog"
    >
      <el-form 
        ref="addForm" 
        :model="addForm" 
        :rules="addFormRules" 
        label-width="120px"
        size="small"
      >
        <el-form-item label="业务来源" prop="bizSouc">
          <el-select 
            v-model="addForm.bizSouc" 
            placeholder="请选择业务来源"
            style="width: 100%"
            clearable
            @change="handleBizSoucChange"
          >
            <el-option
              v-for="item in bizSoucOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="扣减数量" prop="reduceNum">
          <el-input-number
            v-model="addForm.reduceNum"
            controls-position="right"
            :min="1"
            :max="999999"
            style="width: 100%"
            placeholder="请输入扣减数量"
          ></el-input-number>
        </el-form-item>
        
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="addForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注信息"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        
        <!-- 隐藏字段，但在新增时会提交 -->
        <el-form-item v-show="false">
          <el-input v-model="addForm.phrClinicId"></el-input>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button 
          size="small" 
          @click="handleAddDialogClose"
        >
          取消
        </el-button>
        <el-button 
          type="primary" 
          size="small" 
          @click="handleAddSubmit"
          :loading="addLoading"
        >
          确定新增
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 只导入需要的接口
import { reduceList, addReduce, point_souc } from "@/api/points.js";

export default {
  name: 'PointsDeduct',
  data() {
    return {
      // 筛选表单
      filterForm: {
        certNo: '',
        personName: ''
      },
      
      // 新增积分扣减表单
      addForm: {
        bizSouc: 0,           // 业务来源
        phrClinicId: 0,       // 居民健康档案和诊所关系表id
        reduceNum: 1,         // 扣减数量
        remark: ''            // 备注
      },
      
      // 表单验证规则
      addFormRules: {
        bizSouc: [
          { required: true, message: '请选择业务来源', trigger: 'change' }
        ],
        reduceNum: [
          { required: true, message: '请输入扣减数量', trigger: 'blur' },
          { type: 'number', min: 1, message: '扣减数量至少为1', trigger: 'blur' }
        ]
      },
      
      // 业务来源选项
      bizSoucOptions: [],
      
      // 表格数据
      tableData: [],
      
      // 加载状态
      loading: false,
      addLoading: false,
      
      // 分页
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      
      // 表格高度
      tableHeight: 400,
      tableInnerHeight: 400,
      
      // 模态框控制
      showAddDialog: false,
      
      // 表格样式
      fontSize: 'small',
      rowHeightType: 'normal',
      
      // 查看详情数据
      currentDetail: null
    }
  },
  computed: {
    // 行高
    rowHeight() {
      const heightMap = {
        compact: 32,
        normal: 40,
        loose: 48
      };
      return heightMap[this.rowHeightType] || 40;
    },
    
    // 单元格内边距
    cellPadding() {
      const paddingMap = {
        compact: 4,
        normal: 8,
        loose: 12
      };
      return paddingMap[this.rowHeightType] || 8;
    },
    
    // 表头字体大小
    headerFontSize() {
      const sizeMap = {
        small: 12,
        medium: 14,
        large: 16
      };
      return sizeMap[this.fontSize] || 12;
    }
  },
  mounted() {
    // 计算表格高度
    this.calculateTableHeight();
    window.addEventListener('resize', this.calculateTableHeight);
    
    // 加载数据
    this.loadData();
    
    // 加载业务来源选项
    this.loadBizSoucOptions();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  methods: {
    // 计算表格高度
    calculateTableHeight() {
      const windowHeight = window.innerHeight;
      const headerHeight = 60;
      const filterHeight = 100;
      const paginationHeight = 50;
      const margin = 20;
      
      this.tableHeight = windowHeight - headerHeight - filterHeight - paginationHeight - margin;
      this.tableInnerHeight = this.tableHeight - 10;
    },
    
    // 查询
    handleQuery() {
      this.currentPage = 1;
      this.loadData();
    },
    
    // 重置
    handleReset() {
      this.filterForm = {
        certNo: '',
        personName: ''
      };
      this.currentPage = 1;
      this.loadData();
      this.$message.info('筛选条件已重置');
    },
    
    // 加载数据
    async loadData() {
      try {
        this.loading = true;
        
        const params = {
          certNo: this.filterForm.certNo || '',
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          personName: this.filterForm.personName || ''
        };
        
        console.log('查询参数:', params);
        
        const res = await reduceList(params);
        
        if (res && res.code === 200 && res.data) {
          this.tableData = res.data.content || [];
          this.totalCount = res.data.totalSize || 0;
          
          if (this.tableData.length === 0) {
            this.$message.info('未查询到相关数据');
          } else {
            this.$message.success(`查询成功，共 ${this.totalCount} 条数据`);
          }
        } else {
          this.$message.error(res.message || '获取数据失败');
          this.tableData = [];
          this.totalCount = 0;
        }
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message.error('加载数据失败: ' + (error.message || '网络错误'));
        this.tableData = [];
        this.totalCount = 0;
      } finally {
        this.loading = false;
      }
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.loadData();
    },
    
    // 当前页变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadData();
    },
    
    // 新增积分扣减
    handleAddNew() {
      // 重置表单
      this.resetAddForm();
      
      // 打开模态框
      this.showAddDialog = true;
    },
    
    // 处理新增对话框关闭
    handleAddDialogClose() {
      this.$confirm('关闭此界面会清空已填写的内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.showAddDialog = false;
        this.resetAddForm();
      }).catch(() => {
        // 取消关闭
      });
    },
    
    // 重置新增表单
    resetAddForm() {
      this.addForm = {
        bizSouc: 0,
        phrClinicId: 0,
        reduceNum: 1,
        remark: ''
      };
      
      // 重置表单验证
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate();
      }
    },
    
    // 加载业务来源选项
    async loadBizSoucOptions() {
      try {
        const res = await point_souc();
        
        if (res && res.code === 200) {
          this.bizSoucOptions = res.data.map(item => ({
            id: item.id || item.bizSouc,
            name: item.bizSoucName || item.bizSoucName
          }));
          console.log('业务来源选项:', this.bizSoucOptions);
        } else {
          console.error('获取业务来源列表失败:', res.message);
          this.$message.error('获取业务来源列表失败');
        }
      } catch (error) {
        console.error('获取业务来源列表失败:', error);
        this.$message.error('获取业务来源列表失败');
      }
    },
    
    // 业务来源变化
    handleBizSoucChange(value) {
      console.log('选择的业务来源:', value);
    },
    
    // 提交新增积分扣减
    async handleAddSubmit() {
      // 验证表单
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          try {
            this.addLoading = true;
            
            // 准备提交数据
            const submitData = {
              bizSouc: this.addForm.bizSouc,
              phrClinicId: this.addForm.phrClinicId,
              reduceNum: this.addForm.reduceNum,
              remark: this.addForm.remark
            };
            
            console.log('提交数据:', submitData);
            
            // 调用新增接口
            const res = await addReduce(submitData);
            
            if (res && res.code === 200) {
              this.$message.success('已完成新的积分扣减！');
              
              // 关闭对话框
              this.showAddDialog = false;
              
              // 重置表单
              this.resetAddForm();
              
              // 重新加载数据
              this.loadData();
            } else {
              this.$message.error(res.message || '新增积分扣减失败');
            }
          } catch (error) {
            console.error('新增积分扣减失败:', error);
            this.$message.error('新增积分扣减失败: ' + (error.message || '网络错误'));
          } finally {
            this.addLoading = false;
          }
        } else {
          this.$message.warning('请填写完整信息');
          return false;
        }
      });
    },
    
    // 查看详情
    handleViewDetail(row) {
      this.currentDetail = row;
      this.$message.info('查看详情功能待实现，当前查看的数据: ' + row.personName);
      // 这里可以打开详情模态框显示更多信息
    }
  }
}
</script>

<style lang="less">
.purchase-history-container {
  height: calc(90vh - 20px);
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
  padding: 15px;
  overflow: hidden;
  position: relative;
  
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    
    .page-title {
      font-size: 18px;
      font-weight: bold;
      color: #303133;
      margin: 0;
    }
  }
  
  .filter-section {
    background: #fff;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 10px;
    }
  }
  
  .table-section {
    flex: 1;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    
    .table-container {
      height: 100%;
    }
  }
  
  .pagination-section {
    display: flex;
    justify-content: flex-end;
    padding: 10px 0;
  }
}

// 新增积分扣减对话框样式
.add-points-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #e6e6e6;
    padding: 15px 20px 10px;
    
    .el-dialog__title {
      font-size: 16px;
      font-weight: bold;
      color: #409eff;
    }
  }
  
  .el-dialog__body {
    padding: 20px;
    
    .el-form-item {
      margin-bottom: 20px;
    }
  }
  
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    padding: 10px 20px;
    border-top: 1px solid #e6e6e6;
    
    .el-button {
      margin-left: 10px;
    }
  }
}

// Element UI 样式微调
.el-table {
  .el-table__header-wrapper {
    th {
      background-color: #f5f7fa;
    }
  }
  
  .el-table__body-wrapper {
    overflow-y: auto;
  }
}
</style>